var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21324 5.46467C1.88633 7.41718 1.58282 10.8863 3.53533 13.2132C5.48784 15.5402 8.957 15.8437 11.2839 13.8912L13.9651 11.6414C14.3881 11.2864 14.4433 10.6556 14.0883 10.2326L13.1241 9.08351L15.2312 7.31545C15.5485 7.0492 15.5899 6.57613 15.3236 6.25883C15.0574 5.94152 14.5843 5.90013 14.267 6.16639L12.16 7.93444L10.2316 5.63627L12.3386 3.86825C12.6559 3.602 12.6973 3.12893 12.4311 2.81162C12.1648 2.49432 11.6917 2.45293 11.3744 2.71918L9.26739 4.4872L8.30323 3.33817C7.94823 2.91509 7.31747 2.85991 6.8944 3.21491L4.21324 5.46467ZM5.06251 6.71016C3.43368 8.07691 3.26439 10.5568 4.6844 12.2491C6.10441 13.9414 8.57598 14.2053 10.2048 12.8385L12.0816 11.2637C12.3902 11.0047 12.5213 10.8947 12.5226 10.7833C12.5235 10.7009 12.4536 10.6178 12.3322 10.4733L7.70745 4.96176C7.47584 4.68514 7.47554 4.68539 7.18257 4.93122L5.06251 6.71016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIcon);
export default __webpack_public_path__ + "static/media/plug-icon.ee5eff6c03873901ec7b2bf5613505e0.svg";
export { ForwardRef as ReactComponent };